import { createContext, useContext, useEffect, useState, useMemo, useCallback } from "react";

const SecretModeContext = createContext({ enabled: false, toggle: () => {}, blurCls: "" });

const STORAGE_KEY = "blitzz_secret_mode";

export function SecretModeProvider({ children }) {
  const [enabled, setEnabled] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === "1"; } catch (_) { return false; }
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, enabled ? "1" : "0"); } catch (_) {}
  }, [enabled]);

  const toggle = useCallback(() => setEnabled((e) => !e), []);

  // Tailwind-ish class string applied to sensitive nodes
  const blurCls = enabled ? "blur-sm select-none pointer-events-none" : "";

  const value = useMemo(() => ({ enabled, toggle, blurCls }), [enabled, toggle, blurCls]);

  return <SecretModeContext.Provider value={value}>{children}</SecretModeContext.Provider>;
}

export function useSecretMode() { return useContext(SecretModeContext); }

/** Wrap any sensitive value. Hidden when secret mode is enabled. */
export function Hidden({ children, className = "", as: Tag = "span", placeholder = "●●●●●", ...rest }) {
  const { enabled } = useSecretMode();
  if (!enabled) return <Tag className={className} {...rest}>{children}</Tag>;
  return (
    <Tag className={className + " relative"} {...rest}>
      <span className="blur-sm select-none">{children}</span>
      <span className="sr-only">{placeholder}</span>
    </Tag>
  );
}
